import React from 'react';
export default class Modal extends React.Component {
  static displayName = 'Modal';

  backdrop() {
    return <div className='modal-backdrop in' />;
  }

  modal = () => {
    var style = {display: 'block'};
    return (
      <div
        className='modal in'
        tabIndex='-1'
        role='dialog'
        aria-hidden='false'
        style={style}
      >
        <div className={(this.props.modalSize == 'small') ? 'modal-dialog modal-sm' : 'modal-dialog'}>
          <div className='modal-content'>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div id="mod-id">
        {this.backdrop()}
        {this.modal()}
      </div>
    );
  }
}
